module.exports = __webpack_public_path__ + "img/btn_view_a_jz.b2d63170.png";